<template>
      <div class="flex justify-center gap-5 etage-plan__container">
            <div
                  class="mt-2 mr-8 plan"
                  :data-aos="isMobile ? '' : 'fade-left'"
                  data-aos-duration="500"
                  data-aos-easing="ease-in"
            >
                  <img
                        src="../assets/Etage/plan_etage.jpg"
                        alt="Plan du 1er étage"
                  />
                  <div>
                        <!--Etage chambre 2 lits-->
                        <router-link
                              to="/descriptifs/gallerie/etage/chambre-etage"
                              active-class="active"
                              v-on:mouseenter="afficheChambre2EtageItems"
                              v-on:mouseleave="supprimeChambre2EtageItemsStyle"
                        >
                              <div class="etage1_chambre1">
                                    <img
                                          src="../assets/Etage/etage1_chambre1_1.jpg"
                                          alt=""
                                          class="plan__chambre1_1"
                                    />

                                    <img
                                          src="../assets/Etage/etage1_chambre1_2.jpg"
                                          alt=""
                                          class="plan__chambre1_2"
                                    />
                              </div>
                        </router-link>

                        <!--Chambre palière-->
                        <router-link
                              to="/descriptifs/gallerie/etage/chambre-paliere"
                              active-class="active"
                              v-on:mouseenter="afficheChambre1EtageItems"
                              v-on:mouseleave="supprimeChambre1EtageItemsStyle"
                        >
                              <div class="etage1_chambre2">
                                    <img
                                          src="../assets/Etage/etage1_chambre2_1.jpg"
                                          alt=""
                                          class="plan__chambre2_1"
                                    />

                                    <img
                                          src="../assets/Etage/etage1_chambre2_2.jpg"
                                          alt=""
                                          class="plan__chambre2_2"
                                    />
                              </div>
                        </router-link>
                  </div>
            </div>

            <div class="bg-white px-4 rounded-lg text-start">
                  <h1 class="font-semibold">À l'étage :</h1>

                  <ul class="mb-2">
                        <li
                              v-for="description in etageDescription"
                              :key="description.id"
                              :id="description.class"
                              :class="{
                                    applyActive: $route.path.includes(
                                          description.route
                                    ),
                              }"
                        >
                              {{
                                    chooseEnglishVersion
                                          ? description.englishDetails
                                          : description.details
                              }}
                        </li>
                  </ul>
            </div>
      </div>
</template>

<script setup>
const etageDescription = [
      {
            id: 1,
            details: "1 chambre palière (1 lit 1 personne)",
            englishDetails: "One landing room (1 single bed)",
            class: "etage_chambre1",
            route: "chambre-paliere"
      },
      {
            id: 2,
            details: "Placard",
            englishDetails: "Closet",
            class: "etage_placard",
      },
      {
            id: 3,
            details: "1 chambre (2 lits 1 personne)",
            englishDetails: "One bedroom (2 single beds)",
            class: "etage_chambre2",
            route: "chambre-etage"
      },
];

// La chambre 1 du 1er étage
const afficheChambre1EtageItems = () => {
      const chambre1 = document.getElementById("etage_chambre1");

      if (!chambre1.classList.contains("applyActive")) {
            chambre1.classList.add("applyRouteActive");
      }

};

const supprimeChambre1EtageItemsStyle = () => {
      const chambre1 = document.getElementById("etage_chambre1");

      if (!chambre1.classList.contains("applyActive")) {
            chambre1.classList.remove("applyRouteActive");
      }
};

// La chambre 2 du 1er étage
const afficheChambre2EtageItems = () => {
      const chambre2 = document.getElementById("etage_chambre2");

      if (!chambre2.classList.contains("applyActive")) {
            chambre2.classList.add("applyRouteActive");
      }

};

const supprimeChambre2EtageItemsStyle = () => {
      const chambre2 = document.getElementById("etage_chambre2");

      if (!chambre2.classList.contains("applyActive")) {
            chambre2.classList.remove("applyRouteActive");
      }

};
</script>

<style lang="scss" scoped>
.etage-plan__container {
      width: 60%;
      margin: auto;

      @media screen and (max-width: 769px) {
            display: flex;
            flex-direction: column-reverse;
            width: 85%;
      }
}

.applyActive {
      transition: 0.2s ease-in-out;
      margin-left: -0.1em;
      background: #08a045;
      border-radius: 0.5em;
      color: #fff;
      padding: 0 0.5em;
}

.applyRouteActive {
      transition: 0.2s ease-in-out;
      margin-left: -0.1em;
      color: #08a045;
      border-radius: 0.5em;
      font-weight: 700;
      padding: 0 0.5em;
}

.plan {
      position: relative;
      width: 60%;
      margin: auto;

      @media screen and (max-width: 769px) {
            width: 100%;
      }

      @media screen and (max-width: 550px) {
            //display: none;
            //width: 20%;
      }

      // Les chambres de l'étage 1

      .active {
            opacity: 0.5;
      }

      // chambre 1
      &__chambre1_1 {
            position: absolute;
            width: 42%;
            top: 26%;
            left: 0%;
      }

      &__chambre1_2 {
            position: absolute;
            width: 19%;
            bottom: 1.5%;
            left: 36.5%;
      }

      .active .etage1_chambre1 {
            opacity: 0.8;
      }

      .etage1_chambre1 {
            opacity: 0;

            &:hover {
                  transition: 0.5s ease-in;
                  opacity: 0.4;
            }

            @media screen and (max-width: 769px) {
                  opacity: 0.1;
            }

            @media screen and (max-width: 550px) {
                  opacity: 0.1;
            }
      }

      // chambre 2
      &__chambre2_1 {
            position: absolute;
            width: 45%;
            top: 26%;
            right: 0%;
      }

      &__chambre2_2 {
            position: absolute;
            width: 20%;
            top: 26%;
            left: 42.5%;
      }

      .active .etage1_chambre2 {
            opacity: 0.8;
      }

      .etage1_chambre2 {
            opacity: 0;

            &:hover {
                  transition: 0.5s ease-in;
                  opacity: 0.4;
            }

            @media screen and (max-width: 769px) {
                  opacity: 0.1;
            }

            @media screen and (max-width: 550px) {
                  opacity: 0.1;
            }
      }
}
</style>